import * as React from 'react';
import { useLocation } from 'umi';
import Resources from './Resources';
import Collects from './Collects';
import Collections from './Collections';
import { FUtil, FI18n } from '@freelog/tools-lib';
import FCenterLayout from '@/layouts/FCenterLayout';
import * as AHooks from 'ahooks';
import FNavTabs from '@/components/FNavTabs';
import styles from './index.less';
import FPageFooter from '@/components/FPageFooter';
import Income from './Income';
import Transaction from './Transaction';

function List() {
  const location = useLocation();
  const pathname = location.pathname;
  const [showPage, setShowPage] = FUtil.Hook.useGetState<
    'myResources' | 'myCollections' | 'myCollects' | 'income' | 'transaction' | ''
  >('');

  const [$showFooter, set$showFooter] = FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(() => { });

  AHooks.useUnmount(() => { });

  React.useEffect(() => {
    if (pathname === FUtil.LinkTo.myResources()) {
      setShowPage('myResources');
    } else if (pathname === FUtil.LinkTo.myCollections()) {
      setShowPage('myCollections');
    } else if (pathname === FUtil.LinkTo.myCollects()) {
      setShowPage('myCollects');
    } else if (pathname === '/resource/income') {
      setShowPage('income');
    } else if (pathname === '/resource/transaction') {
      setShowPage('transaction');
    }

    set$showFooter(false);
  }, [pathname]);

  AHooks.useDebounceEffect(() => {
    set$showFooter(true);
  }, [pathname], {
    wait: 100
  })

  return (
    <div>
      <div className={styles.top}>
        <div style={{ height: 10 }} />
        <FNavTabs
          options={[
            {
              value: 'myResources',
              label: FI18n.i18nNext.tAuto('my_resources'),
              href: FUtil.LinkTo.myResources(),
            },
            {
              value: 'myCollections',
              // label: '我的合集',
              label: FI18n.i18nNext.tAuto('my_collections_tab'),
              // href: '/resource/collection',
              href: FUtil.LinkTo.myCollections(),
            },
            {
              value: 'myCollects',
              label: FI18n.i18nNext.tAuto('my_collections'),
              href: FUtil.LinkTo.myCollects(),
            },
            {
              value: 'transaction',
              label:
                // '交易记录'
                FI18n.i18nNext.tAuto('creator_nav_transactionhistory'),
              // href: '/resource/transaction',
              href: FUtil.LinkTo.myResourceTransaction(),
            },
            {
              value: 'income',
              label:
                // '创作收入'
                FI18n.i18nNext.tAuto('creator_nav_payouts'),
              // href: '/resource/income',
              href: FUtil.LinkTo.myResourceIncome(),
            },
          ]}
          activated={showPage}
        />
      </div>
      {showPage === 'myResources' && (
        <FCenterLayout>
          <Resources />
        </FCenterLayout>
      )}
      {showPage === 'myCollections' && (
        <FCenterLayout>
          <Collections />
        </FCenterLayout>
      )}
      {showPage === 'myCollects' && (
        <FCenterLayout>
          <Collects />{' '}
        </FCenterLayout>
      )}
      {showPage === 'income' && <Income />}
      {showPage === 'transaction' && <Transaction />}

      {
        $showFooter && (<FPageFooter />)
      }

    </div>
  );
}

export default List;
